import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";

export default function BondsFutures() {
  const [contracts, setContracts] = useState({ Bonds: [], Futures: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchContracts = async () => {
      try {
        setLoading(true);
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return;
        
        const token = await user.getIdToken();
        const res = await fetch("https://getcontracts-5dhfwyjvzq-uc.a.run.app", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Failed to load contracts");
        setContracts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchContracts();
  }, []);

  const fmt = (val) => Number(val || 0).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });

  const fmtDate = (date) => {
    const d = new Date(date);
    return `${String(d.getUTCMonth() + 1).padStart(2, '0')}/${String(d.getUTCDate()).padStart(2, '0')}/${d.getUTCFullYear()}`;
  };

  if (loading) return <p className="blink" style={{ color: "#50e3c2", fontFamily: "'JetBrains Mono', monospace", fontSize: "0.75rem", padding: "15px" }}> LOADING...</p>;
  if (error) return <p style={{ color: "#ff7b72", padding: "15px", fontSize: "0.75rem" }}>SYSTEM ERROR: {error}</p>;
  if (!contracts.Bonds.length && !contracts.Futures.length)
    return <p style={{ color: "#555", padding: "15px", fontSize: "0.75rem" }}>NO ACTIVE CONTRACTS FOUND</p>;

  return (
    <div style={{ 
      padding: "12px", 
      fontFamily: "'JetBrains Mono', monospace", 
      fontSize: "0.7rem", 
      color: "#eee" 
    }}>
      
{contracts.Bonds.map((bond, idx) => {
  const principal = Number(bond.contractValue || 0);
  
  const dailyRatePercent = (Number(bond.contractRate || 0) * 10) / 100; 

  const maturityDays = { BND3: 3, BND7: 7, BND14: 14 }[bond.contractTicker] || 7;

  const expectedInterest = principal * dailyRatePercent * maturityDays;
  const totalAtMaturity = principal + expectedInterest;

  return (
    <div key={`bond-${idx}`} style={{ 
      background: "rgba(255,255,255,0.02)", 
      borderLeft: "3px solid #50e3c2", 
      padding: "10px", 
      marginBottom: "8px",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "4px"
    }}>
      <div style={{ gridColumn: "1 / -1", fontWeight: "bold", color: "#50e3c2", fontSize: "0.75rem" }}>
        {bond.contractTicker}
      </div>
      
      <div style={{ color: "#888" }}>PRINCIPAL:</div>
      <div style={{ textAlign: "right" }}>{fmt(principal)}</div>
      
      <div style={{ color: "#888" }}>DAILY RATE:</div>
      <div style={{ textAlign: "right", color: "#50e3c2" }}>
        {(dailyRatePercent * 100).toFixed(1)}%
      </div>

      <div style={{ color: "#888" }}>TERM ({maturityDays}D):</div>
      <div style={{ textAlign: "right", color: "#fff" }}>
        +{fmt(expectedInterest)}
      </div>

      <div style={{ 
        color: "#aaa", 
        fontWeight: "bold", 
        borderTop: "1px solid rgba(255,255,255,0.1)", 
        paddingTop: "4px", 
        marginTop: "4px" 
      }}>
        TOTAL RETURN:
      </div>
      <div style={{ 
        textAlign: "right", 
        color: "#50e3c2", 
        fontWeight: "bold", 
        borderTop: "1px solid rgba(255,255,255,0.1)", 
        paddingTop: "4px", 
        marginTop: "4px" 
      }}>
        {fmt(totalAtMaturity)}
      </div>

      <div style={{ color: "#888", fontSize: "0.65rem", marginTop: "4px" }}>MATURITY:</div>
      <div style={{ textAlign: "right", fontSize: "0.65rem", marginTop: "4px" }}>
        {fmtDate(bond.contractDate)}
      </div>
    </div>
  );
})}

      {/* Futures Section */}
      {contracts.Futures.length > 0 && (
        <div>
          <div style={{ color: "#ffd700", fontWeight: "bold", borderBottom: "1px solid rgba(255, 215, 0, 0.3)", paddingBottom: "4px", marginBottom: "10px" }}>
            FUTURES
          </div>
          {contracts.Futures.map((future, idx) => (
            <div key={`future-${idx}`} style={{ 
              background: "rgba(255,255,255,0.02)", 
              borderLeft: "3px solid #ffd700", 
              padding: "10px", 
              marginBottom: "8px"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                <span style={{ fontWeight: "bold", color: "#ffd700" }}>{future.contractTicker}</span>
                <span style={{ 
                  background: future.contractDirection === "Long" ? "rgba(0, 255, 0, 0.1)" : "rgba(255, 0, 0, 0.1)", 
                  color: future.contractDirection === "Long" ? "#00ff00" : "#ff7b72",
                  padding: "1px 6px",
                  fontSize: "0.6rem",
                  borderRadius: "2px"
                }}>
                  {future.contractDirection?.toUpperCase()}
                </span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2px" }}>
                <span style={{ color: "#888" }}>STRIKE:</span>
                <span style={{ textAlign: "right" }}>{fmt(future.contractStrikePrice)}</span>
                <span style={{ color: "#888" }}>STAKE:</span>
                <span style={{ textAlign: "right" }}>{fmt(future.contractPrice)}</span>
                <span style={{ color: "#888" }}>POTENTIAL PAY:</span>
                <span style={{ textAlign: "right", color: "#ffd700" }}>{fmt(future.contractPayout)}</span>
                <span style={{ color: "#888" }}>EXPIRY:</span>
                <span style={{ textAlign: "right" }}>{fmtDate(future.contractDate)} 08:00</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}